<template>
  <div class="backdrop container">
    <div class="roll">
      <div class="pl-twelve" id="first">
        <div class="item-content">
          <span class="title">联系客服</span>
          <span class="time">(人工服务时间9:00—18:00)</span>
        </div>
        <div class="phone van-hairline--surround">
          <img src="../../assets/img/telephone.png" alt />
          <a href="tel:0752-2162293">0752-2162293</a>
        </div>
      </div>
      <div class="pl-twelve mt-eight">
        <div class="justified item-content">
          <span class="title required">问题类型</span>
          <span class="text flex-center" @click="showProblem = true">{{matter}}<van-icon name="arrow" /></span>
        </div>
        <div class="justified item-content van-hairline--top" v-if="fileId">
          <span class="title required">{{wordTitle}}名称</span>
          <span class="text van-ellipsis">{{wordName}}</span>
        </div>
        <div class="mt-five van-hairline--surround">
          <textarea
            placeholder="描述您的问题（必填项，5-200个字符)"
            v-model.trim="content"
            maxlength="200"
            focusInput
            style="resize: none;"
          ></textarea>
          <span>{{content.length}}/200</span>
        </div>
      </div>
      <div class="pl-twelve mt-eight">
        <div class="title item-content">上传凭证</div>
        <van-uploader v-model="fileList" multiple :max-count="10" preview-size="2rem" />
      </div>
      <div class="pl-twelve mt-eight">
        <div class="title item-content required">联系方式</div>
        <div class="contact van-hairline--surround">
          <input type="text" placeholder="请输入QQ、手机、邮箱等联系方式" v-model="contact" />
        </div>
      </div>
    </div>
    <div class="partakes" @click="submit">
      <div style="position: absolute;width: 100%;left: 0;top: 0;">提交</div>
    </div>
    <!-- 问题类型弹出层 -->
    <van-action-sheet
      v-model="showProblem"
      :actions="list"
      description="请选择问题类型"
      @select="switchTab"
      close-on-click-action
    />
  </div>
</template>

<script>
import { doFeedback } from "@/api/buyer/index";
export default {
  data() {
    return {
      list: [
        { id:"8", name: "投诉骑手" },
        { id:"9", name: "闪退" },
        { id:"10", name: "页面错位" },
        { id:"11", name: "页面卡顿" },
        { id:"12", name: "商家，商品信息有错误" },
        { id:"13", name: "商品与图片不符" },
        { id:"14", name: "吐槽产品功能" },
      ],
      feedbackType: 0,
      content: "",
      contact: this.GetQueryString("phone"),
      matter: "请选择",
      showProblem: false,
      fileList: [],
      fileId: this.GetQueryString("fileId") || "",
      wordName: this.GetQueryString("wordName"),
      wordTitle: "课件"
    };
  },
  methods: {
    switchTab(value) {
      this.feedbackType = value.id;
      this.matter = value.name;
    },
    submit() {
      if (this.matter == "请选择") {
        this.$toast("请选择问题类型");
        return false;
      }
      if (this.content.length == 0) {
        this.$toast("请描述您的问题");
        return false;
      }
      if (this.content.length < 5) {
        this.$toast("您描述的问题不少于5个字符");
        return false;
      }
      if (this.contact.length == 0) {
        this.$toast("请输入联系方式");
        return false;
      }
      let fd = new FormData();
      fd.append("userType", this.fileId ? "6" : this.GetQueryString("token") ? "1" : "3"); //1 member; 2 seller; 3 游客
      fd.append("feedbackType", this.feedbackType);
      fd.append("content", this.content);
      fd.append("contact", this.contact);
      fd.append("token", this.GetQueryString("token"));
      for (let i = 0; i < this.fileList.length; i++) {
        fd.append("file" + [i + 1], this.fileList[i]? this.fileList[i].file : "");
      }
      fd.append("fileId", this.fileId);
      doFeedback(fd, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        if (res.appStatus.errorCode == 0) {
          this.$toast(res.appStatus.message);
          setTimeout(function() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              //判断是否是微信环境
              //微信环境
              wx.miniProgram.getEnv(function(res) {
                if (res.miniprogram) {
                  // 小程序环境下逻辑
                  wx.miniProgram.navigateBack({ delta: 1 });
                }
              });
            }
          }, 1000);
        } else {
          this.$toast(res.appStatus.message);
        }
      });
    },
  },
  created() {
    if(this.GetQueryString("fileId")) {
      let index = {8: 0, 10: 1, 11: 2}[this.GetQueryString("typeId")];
      this.wordTitle = ["课件", "教案", "微课"][index];
      this.list = [
        { id:"15", name: "课件纠错" },
        { id:"16", name: "教案纠错" },
        { id:"17", name: "微课纠错" },
      ];
      this.switchTab(this.list[index])
    }
    document.title = "客服中心";
  }
};
</script>

<style lang="scss" scoped>
input {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-weight: normal;
  vertical-align: baseline;
}
.flex-center {
  display: flex;
  align-items: center;
}
.justified {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/.van-action-sheet__description {
  height: 50px;
  font-size: 16px;
  font-weight: 800;
  color: #333333;
  margin-top: 10px;
  box-sizing: border-box;
}
/deep/.van-action-sheet__item{
  height: 50px;
  line-height: 50px;
  font-size: 15px;
  color: #1D1D1D;
}
.backdrop {
  height: 100vh;
  font-size: 17px;
  color: #333333;
  background-color: #F0F0F0;
}
.roll {
  text-align: left;
  padding-bottom: 100px;
}
.title {
  font-size: 16px;
  font-weight: 800;
  color: #3d4245;
}
.time {
  margin-left: 5px;
  font-size: 12px;
  color: #b4b4b4;
}
#first {
  .phone {
    height: 34px;
    line-height: 34px;
    font-size: 12px;
    text-align: center;
    box-sizing: border-box;
    img {
      width: 13px;
      height: 13px;
      vertical-align: middle;
    }
    a {
      color: #3e73e3;
      margin-left: 3px;
      vertical-align: middle;
    }
  }
  [class*="van-hairline"]::after {
    border-color: #3e73e3;
  }
}
.item-content {
  height: 40px;
  line-height: 40px;
}
.text {
  max-width: 240px;
  display: inline-block;
  font-size: 14px;
  color: #333333;
}
.required::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
img {
  width: 10px;
  height: 28px;
  margin-left: 10px;
}
p {
  display: flex;
  align-items: center;
}
.label {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  color: #333333;
}
.active {
  color: #ff1310;
}
.pl-twelve {
  padding: 0 12px 12px;
  background-color: #fff;
}
.mt-five {
  margin-top: 5px;
  padding: 9px 4px 4px 12px;
  font-size: 12px;
  textarea {
    border: none;
    width: 100%;
    color: #333333;
  }
  textarea::placeholder {
    color: #b4b4b4;
  }
  span {
    text-align: right;
    display: block;
    color: #b4b4b4;
  }
}
.mt-eight {
  margin-top: 8px;
}
.contact {
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  margin-top: 12px;
  border-radius: 5px;
  padding-left: 12px;
  input {
    width: 100%;
  }
}
.partakes {
  width: 351px;
  height: 49px;
  line-height: 49px;
  margin: 0 12px;
  position: fixed;
  bottom: 12px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  background-color: #2DC660;
  z-index: 100;
  border-radius: 25px;
}
</style>